export const customer = {
    state: () => ({
        isCanna: false,
    }),

    getters: {
        getIsCanna: (state) => state.isCanna,
    },

    actions: {
        setIsCanna({ commit }, data) {
            commit('SET_IS_CANNA', data);
        },
    },
    
    mutations: {
        SET_IS_CANNA(state, data) {
            state.isCanna = data
        },
    },
    
}